module.exports = __webpack_public_path__ + "static/media/CetraRudy_HOME_2_60fps_vimeo.741ae254.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/static/vids/CetraRudy_HOME_2_60fps_vimeo.mp4
// module id = 146
// module chunks = 0